import { render, staticRenderFns } from "./CExamKind.vue?vue&type=template&id=16fbe21e"
import script from "./CExamKind.vue?vue&type=script&lang=js"
export * from "./CExamKind.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/CoreProductivity.Backoffice.Mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16fbe21e')) {
      api.createRecord('16fbe21e', component.options)
    } else {
      api.reload('16fbe21e', component.options)
    }
    module.hot.accept("./CExamKind.vue?vue&type=template&id=16fbe21e", function () {
      api.rerender('16fbe21e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/components/CExamKind.vue"
export default component.exports